import { render, staticRenderFns } from "./LecturesView.vue?vue&type=template&id=19b8368c&"
import script from "./LecturesView.vue?vue&type=script&lang=ts&"
export * from "./LecturesView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports